import {GetTokenStorageKey, GetKcStorageKey} from './StorageKeys'
import {isEmpty} from 'underscore'

class TokenExchanger {

  async exchange(currentUrl, state) {
    const code = this.getCode(currentUrl)

    const redirectUri = currentUrl.href.split('#')[0]

    console.debug('location exchange', window.location)

    const formData = new URLSearchParams()
    formData.append('grant_type', state.grantType)
    formData.append('code', code)
    formData.append('client_id', state.clientId)
    formData.append('redirect_uri', redirectUri)
    formData.append('code_verifier', this.getCodeVerifier(state.id))

    const headers = new Headers()
    headers.append('content-type', 'application/x-www-form-urlencoded')

    var myInit = { 
      method: 'POST',
      headers: headers,
      body: formData,
    }

    const tokenResp = await fetch(state.tokenServerUrl, myInit)
    if(tokenResp.status != 200) {
      const errorMessage = '[TokenExchanger] It was not possible to exchange the OIDC tokens'
      console.error(errorMessage, tokenResp.status)
      throw new Error(errorMessage)
    }

    const content = await tokenResp.json()

    if(state.sessionManagement == 'token') {
      this.storeTokens(content, state)
    }
  }

  getCode(currentUrl) {
    if(!currentUrl) {
      throw Error('[TokenExchanger] currentUrl is not defined')
    }

    const queryString = currentUrl.hash.replace('#','') 
    const urlParams = new URLSearchParams(queryString)
    const code = urlParams.get('code')

    if (isEmpty(code)) {
      throw Error('[TokenExchanger] No code was returned')
    }

    return code
  }

  storeTokens(tokens, state) {
    const storeKey = GetTokenStorageKey(state.clientId)
    const {access_token, id_token, refresh_token} = tokens
    
    localStorage.setItem(storeKey, JSON.stringify({access_token, id_token, refresh_token}))
    sessionStorage.setItem(storeKey, JSON.stringify({access_token, id_token, refresh_token}))
  }

  getCodeVerifier(stateId) {
    const kcState = localStorage.getItem(GetKcStorageKey(stateId))
    if(isEmpty(kcState)) {
      throw Error('[TokenExchanger] keycloack state not found')
    }
    return JSON.parse(kcState).pkceCodeVerifier
  }

}

export default TokenExchanger